import React, { FC, useState } from 'react'
import { WithQuestionnaires } from '../questionnaires/QuestionnaireProvider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import I18n from 'i18n'
import classNames from 'classnames'

const questionnaireKey = 'eq5d5l_rheumatism'

interface Questionnaires {
  areEnabled: boolean | null | undefined
  myOpenResponses?: Array<{ questionnaire: { key: string }, uuid: string }>
  openQuestionnaireUrlForUuid: (uuid: string) => string
}

interface Props {
  hideEq5d5lRheumatism?: boolean
  withContainer?: boolean
  widerButton?: boolean
  questionnaires?: Questionnaires
}

const Eq5d5lRheumatismButton: FC<Props> = ({
  hideEq5d5lRheumatism = false,
  withContainer = false,
  widerButton = false,
  questionnaires
}) => {
  const [enabled] = useState(true)

  if (hideEq5d5lRheumatism || questionnaires?.areEnabled !== true) {
    return null
  }

  const response = questionnaires?.myOpenResponses?.find(
    openResponse => openResponse.questionnaire.key === questionnaireKey
  )

  if (response == null) {
    return null
  }

  const link = questionnaires.openQuestionnaireUrlForUuid(response.uuid)
  const buttonClasses = classNames(
    'waves-effect text-m waves-light button-primary text-primary-color background-background text-medium',
    withContainer && 'button welcome-container-button',
    !withContainer && 'data-button data-detail-page',
    widerButton && 'wider-data-button'
  )

  const Button: FC = () => (
    <a className={buttonClasses} href={link} aria-disabled={!enabled}>
      <FontAwesomeIcon icon='sliders-h' className='button-icon' />
      {I18n.t('components.welcome.fill_out', { title: I18n.t(`group.detail.questionnaires.questionnaires.${questionnaireKey}`) })}
    </a>
  )

  return withContainer
    ? (
      <div className='col s6 m12'>
        <Button />
      </div>
      )
    : (
      <Button />
      )
}

export default WithQuestionnaires(Eq5d5lRheumatismButton)
